import moment from 'moment-timezone'
import { DATE_TIME_ISO_FORMAT } from '../../utils/dateUtils'

type EditRecurringSchedulePayload = {
  TimeZone: string
  Schedules: {
    Edit: Array<{
      VisitTypeGroupId: string | number
      ScheduleId: string | number
      FromDateTime: string
      ToDateTime: string
      RecurringSettings: {
        RecurringType: string
        Frequency: string | number
        EndDateTime: string
        WeekDays: string[]
      }
    }>
  }
  Occurrences: {
    Delete: Array<string | number>
  }
}

type Params = {
  timeZone: string
  visitTypeGroupId: string | number
  scheduleId: string | number
  fromDateTime: string
  toDateTime: string
  recurringType: string
  frequency: string | number
  weekDays: string[]
  occurrenceEndDateTime: string
  occurrenceId: string | number
}

export function buildEditRecurringSchedulePayload({
  timeZone,
  visitTypeGroupId,
  scheduleId,
  fromDateTime,
  toDateTime,
  recurringType,
  frequency,
  weekDays,
  occurrenceEndDateTime,
  occurrenceId,
}: Params): EditRecurringSchedulePayload {
  return {
    TimeZone: timeZone,
    Schedules: {
      Edit: [
        {
          VisitTypeGroupId: visitTypeGroupId,
          ScheduleId: scheduleId,
          FromDateTime: fromDateTime,
          ToDateTime: toDateTime,
          RecurringSettings: {
            RecurringType: recurringType,
            Frequency: frequency,
            EndDateTime: moment(occurrenceEndDateTime).subtract(1, 'day').format(DATE_TIME_ISO_FORMAT),
            WeekDays: weekDays,
          },
        },
      ],
    },
    Occurrences: {
      Delete: [occurrenceId],
    },
  }
}
